import { IPrescriptionPosition } from '@alberta/konexi-shared/dist/prescription/prescription-position';
import { PrescriptionNodeValueArticleLines } from 'src/app/shared/models/prescription/prescription-node-value.model';

import { PrescriptionPositionViewModel } from '../view-models/prescription-position-view-model';

export function convertArticleLines(articleLines: PrescriptionNodeValueArticleLines[]): IPrescriptionPosition[] {
  const positions = [];
  for (const articleLine of articleLines ?? []) {
    const packagingUnit = articleLine.article?.packagingUnits?.find(item => item._id === articleLine.packagingUnitId);
    const position = new PrescriptionPositionViewModel();
    position.name = articleLine.article?.name;
    position.articleId = articleLine.articleId;
    position.description = articleLine.article?.description;
    position.contractId = articleLine.contractId;
    position.productGroupId = articleLine.article?.productGroupId;
    position.applienceNo = articleLine.article?.medicalAidPositionNumber;
    position.pcnNo = packagingUnit?.pcn;
    position.quantity = articleLine.quantity;
    position.unit =
      articleLine.unit === 'Stk' ? articleLine.unit : `${articleLine.unit} (${packagingUnit?.quantity} Stk)`;
    positions.push(position);
  }
  return positions;
}
